import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/ManagerAccount/ManagerLogin',
    method: 'post',
    data
  })
}

export function getInfo() {
  return request({
    url: '/Manager/ManagerGetPermissionsList',
    method: 'post',
  })
}

export function logout() {
  return request({
    url: '/ManagerAccount/Logout',
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js